<script lang="ts">
  import { afterNavigate } from '$app/navigation';
  import '$shared/helpers/extensions';

  afterNavigate((navigation) => {
    dispatchEvent(new CustomEvent('service:route-change', { detail: navigation }));
  });
</script>

<main>
  <slot />
</main>
